import { useState, useEffect } from 'react';
import { rounder } from '@lib/helpers';
import { Card } from 'react-bootstrap';
import { Trans, ApiTrans, propTrans } from '@lib/i18n';
import { Ico35 } from '@icons/new';

const TaxesTypologiesTable = ({ taxes, filterForRegion }) => {
  const [taxesData, setTaxesData] = useState([]);
  console.log(taxes);

  useEffect(() => {
    let filter = filterForRegion === 'total' ? '' : filterForRegion;
    setTaxesData(
      taxes.filter((tax) => {
        // console.log('TAXES', tax, filter);
        return tax.region === filter;
      })
    ); //to filter
  }, [taxes, filterForRegion]);

  return (
    <div className='col-lg-6 col-md-12 col-sm-12 layout-charts d-flex container-card mb-5'>
      <Card className='cards-utente d-none d-md-block card-table'>
        <Card.Body>
          <Ico35 className='logo-card ico-box-blue' />
          <Card.Title>
            <Trans code='A0183' />
          </Card.Title>
          <table className='investment-table'>
            <thead>
              <tr>
                <th className='value-label'>
                  <Trans code='A0201' />
                </th>
                <th>
                  <Trans code='A0327' />
                </th>
              </tr>
            </thead>
            <tbody>
              {taxesData
                ?.filter((k) => k.propertyName !== 'total')
                .map((el) => {
                  const value = el.propertyValue;
                  return (
                    <tr key={el.propertyName}>
                      <td className='value-label'>
                        <ApiTrans
                          scope='taxes'
                          prop={el.propertyName.split(' ')[0].toLowerCase()}
                        />
                      </td>
                      <td>{rounder(value)}</td>
                    </tr>
                  );
                })}
            </tbody>
            <tfoot>
              <tr>
                <th className='value-label'>{propTrans({ prop: 'A0111', scope: 'taxes' })}</th>
                <th>
                  {rounder(
                    taxesData
                      .filter((el) => el.propertyName !== 'total')
                      .reduce((acc, curr) => acc + curr.propertyValue, 0)
                  )}
                </th>
              </tr>
            </tfoot>
          </table>
          <p className='va-desc'>
            <Trans code='A0053' />
          </p>
        </Card.Body>
      </Card>
    </div>
  );
};

export default TaxesTypologiesTable;
